import React from 'react'
import objectdetection from "./Imgs/ObjectDetection.jpg"
import Imagelabel from "./Imgs/ImageLabel.png"
import news from "./Imgs/news.jpg"

const Portfolio = () => {
    const portfoloios = [
        {
            id: 1,
            src: objectdetection,
            project: "Object detection using Yolov5spt",
            href: "https://github.com/Riaz-Awan/Image-object-detection",
            // code links nd demo lilks here
            // using inder we get where the user clicks
        },
        {
            id: 2,
            src: Imagelabel,
            project:"Image label detection",
            href:"https://github.com/Riaz-Awan/Image-object-detection",
        },
        {
            id: 3,
            src: news ,
            project:"Voice Assistant News App",
            href:"https://github.com/Riaz-Awan/AI-News-Application"
            // src: nvbar,
        },
    ];
    return (
        <div name="portfolio" className='h-dvh w-full bg-gradient-to-b from-black to-gray-800 text-white md:h-screen'>
            <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
                <div className='pb-8 '>
                    <p className='text-4xl fone-bold inline border-b-4 border-gray-500'>Portfolio</p>
                    <p className='py-6'>Check out some of my projects here</p>
                </div>


                <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0'>
                    {
                        portfoloios.map(({ id, src, project,href }) => (

                            <div
                                key={id} className='shadow-md shadow-gray-600 rounded-lg'>
                                <img
                                    src={src}
                                    alt=""
                                    className='rounded-md duration-200 hover:scale-105 h-48 w-full' />

                                <div className='flex items-center justify-center'>
                                    <button className='text-sm px-1 md:px-3 py-3 m-2 duration-200 hover:scale-105' >{project}</button>
                                    <a href={href}><button className='text-sm px-1 md:px-3 py-3 m-1 md:m-2  duration-200 hover:scale-105' >code</button></a>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    )
}

export default Portfolio
